import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=9d75618e&scoped=true&"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts&"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=9d75618e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d75618e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow,VTooltip})
